<script lang="ts">
    import Particles from "svelte-particles";
    import { loadFull } from "tsparticles";
    import Form from "./components/Form.svelte";
    import {language, checkLang} from "./store/store.js"

    export let name: string;

    let innerWidth;



    // set setting for background
    let particlesConfig = {
        preset: "triangles",
        particles: {
            number: {
                value: 40},
            color: {
                value: '#020202'
            },
            links: {
                enable: true,
                color: '#000000'
            },
            move: {
                enable: true
            },
        },
        retina_detect: true,
    };

    // TODO добавить чтобы считалось когда уже смонтировано все
    $: if (innerWidth <= 400) {
        // console.log("w: ", innerWidth)
        particlesConfig.particles.number.value = Math.round(innerWidth/10)
        // console.log("value: ", Math.round(innerWidth/10))
    } else {
        // console.log("w: ", innerWidth)
        particlesConfig.particles.number.value = Math.round(innerWidth/19)
        // console.log("value: ", Math.round(innerWidth/19))
    }
    // check the language user and set state
    let userLang = navigator.language || navigator.userLanguage;

    // set language and checkLang set true
    if (userLang === 'ru-RU' && $checkLang === false) {
        language.set("RU")
        checkLang.set(true)
    } else {
        language.set("EN")
        checkLang.set(true)
    }

    function setLang() {
        switch ($language) {
            case "RU" : return language.set("EN")
            case "EN" : return language.set("RU")
        }
    }
    let handleParticlesLoaded = (e) => {
        const container = e.detail.particles;
        // use container to call its methods
    }

    let particlesInit = async (main) => {
        await loadFull(main);
        // await loadTrianglesPreset(engine);
    }

    // set text on current language
    function langTextSet(lang) {
        switch (lang) {
            case "RU" : return {
                discript : "Мы создаем ИИ для планирования производства",
                comingDate : "Релиз в 2023",
                contact : "Связаться с нами:",
                placeholder: "Введите ваш Email",
                buttonSubmitForm: "Подписаться на новости",
                errorValidateMessage: "Введите валидный email"
            }
            case "EN" : return  {
                discript : "We create the engine to optimize production planning",
                comingDate : "Coming in 2023",
                contact : "Contact us:",
                placeholder: "Enter your email",
                buttonSubmitForm: "Subscribe",
                errorValidateMessage: 'Please enter a valid email'
            }
        }
    }

    let text = {}
    // subscribe on language in store
    language.subscribe( value => {text = langTextSet(value)
    })
</script>

 <svelte:window bind:innerWidth = {innerWidth}  />

<main>
    <button class="lang" on:click={setLang}>{$language}</button>
    <h1>{name}</h1>
    <p>{text?.discript}</p>
    <p>{text?.comingDate}</p>
    <p>{text?.contact} <a href="mailto:contact@eradevelop.com">contact@eradevelop.com</a></p>
    <Form text={text}/>
    <Particles id="tsparticles" options={particlesConfig} on:particlesLoaded={handleParticlesLoaded}
               particlesInit={particlesInit}/>
</main>
<style>
    main {
        display:flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        text-align: center;
        padding: 1em;
        max-width: 100%;
        margin: 0 auto;
    }
    Form {
        z-index: 100
    }
    h1 {
        color: #000000;
        /*text-transform: uppercase;*/
        font-size: 4em;
        font-weight: 100;
        z-index: 100
    }
    .lang {
        margin-left: auto;
    }
    p {
        color: #000000;
        z-index: 100
    }

    @media (min-width: 640px) {
        main {
            max-width: none;
        }
    }
</style>
